<template>
    <div class="modal-footer">
        <slot></slot>
    </div>
</template>

<script>
export default {
    /**
        tag
        name: ks-modal-footer
        description: modal footer
    **/
    name: ''
}
</script>